import { usePortfolioRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import { useRedirectGuard } from "web_myplann/Shared/Hooks/useRedirectGuard";

type LockableItem = {
	allowEditByClient: boolean;
};

export const useEditAccessGuard = (
	item: LockableItem | undefined,
	detailRoute: string,
) => {
	const { hasRight: hasPortfolioRight, isPending: isRightPending } =
		usePortfolioRightOptional();
	const isLockedByAdvisor = item !== undefined && !item.allowEditByClient;

	useRedirectGuard(
		(!isRightPending && !hasPortfolioRight) || isLockedByAdvisor,
		detailRoute,
	);

	return { isLockedByAdvisor };
};
